/**
 * Renders nothing; exists so the identity hook runs *inside* an auth provider.
 * Both layouts mount their provider within their own JSX, so a hook called in
 * the layout function body would sit above the provider and throw.
 */
import { useSupportChatIdentity } from '@/hooks/useSupportChatIdentity';

export function SupportChatIdentityBridge(): null {
  useSupportChatIdentity();
  return null;
}
